import { memo } from 'react';

const DownloadIcon = memo(() => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_5844_28510)">
            <path
                d="M19.3825 6.79264C18.5719 2.72551 14.6177 0.0856802 10.5506 0.896287C7.57584 1.48918 5.24985 3.8137 4.65512 6.78807C1.7714 7.1204 -0.297142 9.72746 0.0350106 12.6114C0.340796 15.2655 2.58878 17.2679 5.26047 17.2661H9.01486C9.42959 17.2661 9.76578 16.9299 9.76578 16.5152C9.76578 16.1004 9.42959 15.7643 9.01486 15.7643H5.26047C3.1868 15.752 1.51597 14.0612 1.52805 11.9877C1.54032 9.91404 3.23111 8.24302 5.30478 8.25529C5.68747 8.25529 6.009 7.96745 6.05112 7.58696C6.43234 4.29143 9.41311 1.92882 12.7088 2.31004C15.4796 2.63048 17.6653 4.81621 17.9857 7.58696C18.0487 7.97422 18.3842 8.25785 18.7764 8.25529C20.8501 8.25529 22.531 9.9362 22.531 12.0099C22.531 14.0833 20.8501 15.7643 18.7764 15.7643H15.022C14.6073 15.7643 14.2711 16.1004 14.2711 16.5152C14.2711 16.9299 14.6073 17.2661 15.022 17.2661H18.7766C21.6793 17.248 24.018 14.88 24 11.9773C23.9835 9.33378 22.0064 7.11381 19.3825 6.79264Z"
                fill="currentColor"
            />
            <path
                d="M14.6728 18.8057L12.7693 20.7098V11.2592C12.7693 10.8445 12.4331 10.5083 12.0185 10.5083C11.6038 10.5083 11.2676 10.8445 11.2676 11.2592V20.7098L9.36405 18.8057C9.07603 18.5073 8.6005 18.499 8.30222 18.7872C8.00394 19.0752 7.9957 19.5506 8.28373 19.8489C8.28995 19.8553 8.296 19.8613 8.30222 19.8674L11.4868 23.0527C11.5564 23.1221 11.6388 23.1772 11.7294 23.2149C11.9142 23.2931 12.1227 23.2931 12.3077 23.2149C12.3983 23.1772 12.4807 23.1221 12.5501 23.0527L15.7347 19.8674C16.0329 19.5793 16.0412 19.104 15.7531 18.8057C15.4649 18.5074 14.9896 18.4992 14.6913 18.7872C14.6851 18.7933 14.6789 18.7993 14.6728 18.8057Z"
                fill="currentColor"
            />
        </g>
        <defs>
            <clipPath id="clip0_5844_28510">
                <rect width="24" height="24" fill="white" />
            </clipPath>
        </defs>
    </svg>
));

export default DownloadIcon;
